import { platformSchema, regionSchema, supportStateSchema } from '@plathunt/types';
/**
 * Mapping DB-Zeile -> Domain Type. Liegt bewusst im Repository Layer:
 * die App haengt nicht an Tabellenspalten.
 */
function toPlatforms(raw) {
    if (!Array.isArray(raw))
        return [];
    const result = [];
    for (const value of raw) {
        const parsed = platformSchema.safeParse(value);
        if (parsed.success)
            result.push(parsed.data);
    }
    return result;
}
function toSupportState(raw) {
    const parsed = supportStateSchema.safeParse(raw);
    return parsed.success ? parsed.data : 'catalog';
}
export function mapGameRow(row) {
    return {
        id: row.id,
        title: row.title,
        slug: row.slug,
        franchiseId: row.franchise_id,
        coverUrl: row.cover_url,
        releaseDate: row.release_date,
        publisher: row.publisher,
        developer: row.developer,
        platforms: toPlatforms(row.platforms),
        supportState: toSupportState(row.support_state),
        igdbId: row.igdb_id,
    };
}
export function mapFranchiseRow(row) {
    return {
        id: row.id,
        name: row.name,
        slug: row.slug,
        popularityRank: row.popularity_rank,
        igdbId: row.igdb_id,
    };
}
export function mapTrophySetRow(row) {
    const region = regionSchema.safeParse(row.region);
    const platform = platformSchema.safeParse(row.platform);
    return {
        id: row.id,
        gameId: row.game_id,
        npCommunicationId: row.np_communication_id,
        platform: platform.success ? platform.data : 'ps5',
        region: region.success ? region.data : 'unknown',
        version: row.version,
        title: row.title,
        trophyTitleIconUrl: row.trophy_title_icon_url,
        trophyCount: {
            bronze: row.count_bronze,
            silver: row.count_silver,
            gold: row.count_gold,
            platinum: row.count_platinum,
            total: row.count_total,
        },
        hasPlatinum: row.has_platinum,
        supportState: toSupportState(row.support_state),
        psnLastSyncedAt: row.psn_last_synced_at,
    };
}
//# sourceMappingURL=mapping.js.map